module.exports = __webpack_public_path__ + "static/media/Blitzcrank.b6f2e981.png";